import React, { useState } from 'react';
import { ToastMain ,SweetAlertShow } from '../../master/Master';
import { GetMarketingSchool } from '../../../api/MarketinService';

const Studentaddfrom = () => {
  const[data, setData]=useState('');
  const[source, setSource]=useState('');


  const getSource = async () =>{
    const response = GetMarketingSchool();
    if(response.data.status){
      setSource(response?.data);
      alert(response)
    }else{
      // ToastMain.fire({
      //   icon:'info',
      //   title: response?.data?.message || 'something went wrong'

      // })

      SweetAlertShow('info','Warning', response?.data?.message)
    }

  }
    return (
        <div>
              <div className="container mt-4">
                <div className=" p-4">
                  <form>
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <label className="form-label fw-bold">
                          School Name
                        </label>
                        <select className="form-select">
                          <option>Select School</option>
                        </select>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">
                          Student Name
                        </label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">
                          Father's Name
                        </label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">mobile No</label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">
                          Other Mobile
                        </label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">
                          Education Level
                        </label>
                        <select className="form-select">
                          <option>12th Pass</option>
                          <option>10th Pass</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Village</label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Tehsil</label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">State</label>
                        <select className="form-select">
                          <option>Select State</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">District</label>
                        <select className="form-select">
                          <option>Select District</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Block</label>
                        <select className="form-select">
                          <option>Select Block</option>
                        </select>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
        </div>
    );
}

export default Studentaddfrom;
